import { gql } from "@apollo/client";

export const UpdateToastMessage = gql`
    mutation UpdateToastMessage ($id: ID!, $input: ToastMessageUpdateAttributesInput!){
        updateToastMessage (id: $id, input: $input) {
            id
            message
            fromDate
            toDate
            status
        }
    }
`;
